import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {ItemDefinitionViewType} from 'src/app/item-tracker/ItemDefinitionForm';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export class ItemDefinitionRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  isGoHomeEnabled(): boolean {
    return this.enableGoHome;
  }

  getCreateRoute(): string {
    return PathUtility.ItemDefinitionCreate();
  }

  getEditRoute(id: string | number): string {
    const view: ItemDefinitionViewType = this.parameters['view'] || 'content';
    return PathUtility.ItemDefinitionEdit(id, view);
  }

  getViewRoute(id: string | number): string {
    const view: ItemDefinitionViewType = this.parameters['view'] || 'content';
    return PathUtility.ItemDefinitionView(id, view);
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    return PathUtility.ItemDefinitions();
  }
}
